import React from "react";
import "./Journey.scss";
import PrimaryButton from "../../../../common/primaryButton";
import { useNavigate } from "react-router-dom";

const Journey = () => {
  const navigate = useNavigate();
  const NavigateToContact = () => {
    navigate("/contact-us");
  };
  return (
    <section className="section journey-section">
      <div className="container">
        <div className="heading" data-aos="fade-up">
          <span>FULL ACCESS</span>
          <h3>Complete expert support along the journey</h3>
        </div>
        <div className="grid">
          <div className="grid-row">
            <div className="column" data-aos="fade-right">
              <span>Do I need genetic counseling?</span>
              <p>
                "We strongly encourage all patients interested in PGT to have an
                appointment with genetic counselors.{" "}
                <span>
                  This consultation will ensure you fully understand the risks,
                  benefits, and limitations of this testing."
                </span>
              </p>
            </div>
            <div className="column" data-aos="fade-right">
              <span>What are the benefits of PGT-A?</span>
              <p>
                Embryos with aneuploidy are more likely to result in a failed
                transfer or miscarriage{" "}
                <span>
                  PGT-A results may increase the chances of a successful
                  pregnancy by providing an informed selection of embryos that
                  are typically randomly selected.
                </span>
              </p>
            </div>
          </div>
          <PrimaryButton
            handleClick={NavigateToContact}
            primaryBtnText="Get in Touch"
            aos="fade-left"
          />
        </div>

        <div className="content">
          <div className="desc">
            <h3>Dr Amelie </h3>
            <p>
              "Our genetic counselors offer full pre- and post-test counseling
              for all fertility-related genetic testing."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Journey;
